import googleService from './GoogleService';
import { NoResultsError } from './errors';
import {
    filterResultsWithGooglePlaceIds,
} from './googlePlaceFilter';

export {
    NoResultsError,
    filterResultsWithGooglePlaceIds,
    googleService,
};
export default googleService;
